// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { productBrandStyles } from "@insite/content-library/Components/ProductBrand";
import { TypographyProps } from "@insite/mobius/Typography";
import { css } from "styled-components";

const nameText: TypographyProps = {
    css: css`
        width: 100%;
    `,
    size: "13px",
    weight: 600,
};

productBrandStyles.nameLink = {
    css: css`
        width: 100%;
        // xng-change - STR-2589
        white-space: nowrap;
    `,
    typographyProps: nameText,
};